import DataTable from '../../../../../components/Datatable';
import Loading from '../../../../../components/Loading';
import { COLUMNS, EXTRA_COLUMNS } from './keys';
import { getSortKeys, setAdditionalStyles } from '../../../../../helpers/table';
import { query } from './query';
import { Component } from 'react';
import { v4 as uuid } from 'uuid';
import { withTranslation } from 'react-i18next';

class PromptsPerformingByTag extends Component {
    constructor() {
        super();

        this.getData = this.getData.bind(this);
        this.forceRun = this.forceRun.bind(this);
        this.handleMoodeChange = this.handleMoodeChange.bind(this);

        const isDark = JSON.parse(localStorage.getItem('dark-mode'));

        this.state = {
            data: [],
            loading: true,
            totalMentions: 1,
            isDark: !!isDark,
        };
    }

    componentDidMount() {
        document.addEventListener('changeMoodEvent', this.handleMoodeChange);
    }

    componentWillUnmount() {
        document.removeEventListener('changeMoodEvent', this.handleMoodeChange);
    }

    handleMoodeChange() {
        const isDark = JSON.parse(localStorage.getItem('dark-mode'));
        this.setState({ isDark });
    }

    async getData({ force = false, alreadyInQueue = false }) {
        try {
            this.query = query({
                prompt_uids: this.props.prompt_uids,
                base_domain: this.props.project?.own_domain,
                brand: this.props.project?.own_product_name,
            });
            this.setState({ loading: true });

            this.query.bind(this.setState.bind(this));
            const results = await this.query.update({ force, alreadyInQueue });
            const data = results?.map((x) => ({ id: uuid(), ...x }));
            this.setState({
                data,
                loading: false,
            });
        } catch (err) {
            console.log(err);
        }
    }

    forceRun() {
        this.getData({ force: true, alreadyInQueue: true });
    }

    async componentDidUpdate(prevProps) {
        if (
            !this.props.globalLoading &&
            this.props.globalLoading !== prevProps.globalLoading &&
            !this.props.prompt_uids?.length
        ) {
            this.setState({ data: [], loading: false });
        }
        if (
            JSON.stringify(prevProps.prompt_uids) !== JSON.stringify(this.props.prompt_uids) ||
            JSON.stringify(prevProps.platforms) !== JSON.stringify(this.props.platforms)
        ) {
            this.getData({});
        }

        if (this.props.updateAll !== prevProps.updateAll) {
            this.forceRun();
        }
    }

    searchFunction(data, search) {
        if (!search) return data;
        return data.filter((item) => item.prompt?.toLowerCase().includes(search.toLowerCase()));
    }

    render() {
        const { t } = this.props;
        const columns = COLUMNS(t, this.state.isDark);
        const data = this.props.tagsWithPrompts?.map((item) => {
            const foundData = this.state.data?.filter((dataItem) =>
                item.prompts.includes(dataItem.prompt?.toLowerCase()),
            );
            return {
                tag: item.tag,
                prompts: item.prompts,
                promptsData: foundData ?? [],
            };
        });

        const customEmptyMessage = (
            <div>
                There is no tags, please apply tags to your prompts{' '}
                <button className="button-like-link" onClick={this.props.moveToPrompts}>
                    here
                </button>
            </div>
        );

        return (
            <div className="card table-main rounded-main ">
                {this.state.loading && <Loading padding={10} />}
                {!this.state.loading && (
                    <DataTable
                        nodes={data}
                        sortFns={getSortKeys(columns)}
                        searchFunction={this.searchFunction}
                        COLUMNS={columns}
                        header={t('ai_tracking.global.prompts_performing_by_tag')}
                        customEmptyMessage={customEmptyMessage}
                        forceRun={this.forceRun}
                        additionalStyles={setAdditionalStyles(columns)}
                        headerHasCustomStyles
                        EXTRA_HEADER={EXTRA_COLUMNS(t, this.state.isDark)}
                    />
                )}
            </div>
        );
    }
}

export default withTranslation()(PromptsPerformingByTag);
